import styled from 'styled-components';
import { animated } from 'react-spring';
import { COLORS } from '../../styles/variables';
import { device } from '../../styles/devices';

export const TagsWrapper = styled.section`
  position: relative;
`;
export const FilterTagWrapper = styled.div`
  padding-top: 16px;
  display: flex;
  flex-direction: row;
  gap: 16px;
  padding-bottom: 28px;
  /* flex-wrap: wrap; */
  overflow-x: scroll;
  width: 100%;
  white-space: nowrap;
  ::-webkit-scrollbar {
    display: none;
  }
  @media ${device.laptop} {
    gap: 12px;
    padding-top: 24px;
    padding-bottom: 32px;
    flex-wrap: wrap;
  }
`;
export const FilterTag = styled.div`
  padding: 4px 12px;
  height: 32px;
  background-color: rgba(0, 0, 0, 0.05);
  display: flex;
  flex-direction: row;
  align-items: flex-end;
  justify-content: space-between;
  gap: 8px;
`;
export const Label = styled.p`
  font-family: Audi Type;
  font-size: 16px;
  line-height: 24px;
  letter-spacing: 0.003px;
`;

export const IconBox = styled.button`
  background: initial;
  padding: 0;
  border: none;
  height: 24px;
  width: 24px;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  cursor: pointer;
`;

export const ResetFiltersCTA = styled.button`
  font-family: Audi Type;
  color: ${COLORS.grey80};
  border: none;
  background: initial;
  display: flex;
  flex-direction: row;
  font-size: 16px;
  line-height: 24px;
  letter-spacing: 0.003px;
  gap: 4px;
  cursor: pointer;
  margin-right: 8px;

  @media ${device.laptop} {
    margin-right: 0;
    color: ${COLORS.grey60};
  }
`;

export const ResetLabel = styled.p`
  padding-bottom: 4px;
  border-bottom: 1px solid ${COLORS.grey80};

  @media ${device.laptop} {
    border-bottom: 1px solid ${COLORS.grey60};
  }
`;

export const FilterCount = styled.p``;

export const LeftShadow = styled(animated.div)`
  position: absolute;
  left: 0;
  width: 62px;
  height: 56px;
  flex-shrink: 0;
  background: linear-gradient(
    90deg,
    #f2f2f2 0%,
    rgba(242, 242, 242, 0.66) 44.38%,
    rgba(242, 242, 242, 0) 93.64%
  );
`;
export const RightShadow = styled(animated.div)`
  position: absolute;
  right: 0;
  width: 62px;
  height: 56px;
  flex-shrink: 0;
  background: linear-gradient(
    270deg,
    #f2f2f2 0%,
    rgba(242, 242, 242, 0.66) 44.38%,
    rgba(242, 242, 242, 0) 93.64%
  );
`;

// export const Wrapper = styled(animated.section)`
//     z-index: 1000;
// `;

export const Wrapper = styled(animated.section)`
  background-color: ${COLORS.black};
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  top: 0;
  z-index: 1000;
`;
export const RemoveModal = styled(animated.div)`
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  max-height: 324px;
  background-color: ${COLORS.white};
  z-index: 1001;
`;

export const IconWrapper = styled.div`
  height: 48px;
  width: 48px;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
`;

export const RemoveHeader = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-end;
`;

export const RemoveContent = styled.div`
  padding: 12px 16px 16px 16px;
  height: 100%;
`;

export const RemoveText = styled.p`
  font-family: Audi Type;
  font-size: 16px;
  font-style: normal;
  font-weight: 700;
  line-height: 24px; /* 150% */
  letter-spacing: 0.002px;
  padding-bottom: 64px;
`;

export const CtaWrapper = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

export const PrimaryCta = styled.button`
  width: 100%;
  height: 56px;
  cursor: pointer;
  border: 1px solid ${COLORS.black};
  color: ${COLORS.white};
  background-color: ${COLORS.black};
`;
export const SecondaryCta = styled.button`
  width: 100%;
  height: 56px;
  cursor: pointer;
  border: 1px solid ${COLORS.black};
  color: ${COLORS.black};
  background-color: ${COLORS.white};
`;
